/*
 * ANIME CRUSH — TYPE-AWARE IMAGE FITTING
 *
 * One job: mark an image whose SOURCE PHOTO is not close to square, so CSS can
 * contain it instead of covering it and nothing gets cut off.
 *
 * WHY IN JAVASCRIPT AT ALL. The decision needs naturalWidth and naturalHeight,
 * which exist nowhere else - not in Liquid, not in CSS. Shopify's image object
 * carries dimensions, but the theme renders product cards through several sections
 * and snippets and some of them hand CSS a src without them.
 *
 * WHY IT IS ALMOST ALWAYS A NO-OP, which is the honest framing. Measured across 36
 * product images on five collections: 35 are square and one is 2:3. So this marks
 * roughly one card in thirty-six. It is not a layout system; it is a guard for the
 * portrait photo that would otherwise lose a third of itself to a square frame.
 *
 * IT ADDS A CLASS AND NOTHING ELSE. No dimensions are written, no styles are set
 * inline, nothing is measured that could force a reflow beyond reading two
 * intrinsic numbers. The card's box is reserved in CSS, so marking an image cannot
 * move anything.
 */
(function () {
  'use strict';

  /* How far from square before containing is the better answer. 1.25 lets the
     common 4:5 and 5:4 product shots keep `cover` - they lose a sliver at worst -
     and catches 2:3 and 3:2, which lose a third. */
  var THRESHOLD = 1.25;

  function assess(img) {
    if (!img || img.getAttribute('data-ac-media-assessed') === '1') return;
    var w = img.naturalWidth, h = img.naturalHeight;
    if (!w || !h) return;                       /* not decoded yet */
    img.setAttribute('data-ac-media-assessed', '1');

    var ratio = w > h ? (w / h) : (h / w);
    if (ratio > THRESHOLD) {
      img.classList.add('ac-media--contain');
      img.setAttribute('data-ac-media-fit', 'contain ' + w + 'x' + h);
    } else {
      img.setAttribute('data-ac-media-fit', 'cover ' + w + 'x' + h);
    }
  }

  function scan(root) {
    var sel = '.ProductItem__ImageWrapper img, .ProductItem .AspectRatio img, .AcRailItem__Media img';
    Array.prototype.forEach.call((root || document).querySelectorAll(sel), function (img) {
      if (img.complete) { assess(img); return; }
      /* `load` fires per image; once is enough and the listener removes itself. */
      img.addEventListener('load', function () { assess(img); }, { once: true });
    });
  }

  function init() {
    scan(document);

    /* The grid is paginated and some sections inject cards after load, so watch for
       new ones rather than assuming the first pass saw everything. Observing
       childList only - attributes would fire on every lazysizes swap. */
    if (typeof MutationObserver === 'function') {
      var obs = new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            if (added[j].nodeType === 1) scan(added[j]);
          }
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
